import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1033RenameUmlStatus: 'idle',
    startProcess1033RenameUmlError: undefined as any,
    loadUserParamsProcess1033RenameUmlStatus: 'idle',
    loadUserParamsProcess1033RenameUmlError: undefined as any,

    process1033RenameUmlList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1033RenameUml = createAsyncThunk('process1033RenameUmlSlice/startProcess1033RenameUml', async ({ process1033RenameUml }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1033RenameUml/`,
        prepareData(process1033RenameUml),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1033RenameUmlStatus } = getState().process1033RenameUmlSlice
        return startProcess1033RenameUmlStatus !== 'pending'
    }
})

export const loadUserParamsProcess1033RenameUml = createAsyncThunk('process1033RenameUmlSlice/loadUserParamsProcess1033RenameUml', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1033RenameUml/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1033RenameUmlStatus } = getState().process1033RenameUmlSlice
        return loadUserParamsProcess1033RenameUmlStatus !== 'pending'
    }
})

const Process1033RenameUmlSlice = createSlice({
    name: 'process1033RenameUmlSlice',
    initialState,
    reducers: {
        resetstartProcess1033RenameUml: (state) => {
            state.job = undefined
            state.startProcess1033RenameUmlError = undefined
        },
        resetstartProcess1033RenameUmlError: (state) => {
            state.startProcess1033RenameUmlError = undefined
        },
        resetloadUserParamsProcess1033RenameUml: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1033RenameUmlError = undefined
        },
        resetloadUserParamsProcess1033RenameUmlError: (state) => {
            state.loadUserParamsProcess1033RenameUmlError = undefined
        },
        removeFromProcess1033RenameUmlListById: (state, action) => {
            state.process1033RenameUmlList = state.process1033RenameUmlList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1033RenameUmlListByIds: (state, action) => {
            state.process1033RenameUmlList = state.process1033RenameUmlList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1033RenameUmlList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1033RenameUmlStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1033RenameUmlList = []
            state.startProcess1033RenameUmlStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1033RenameUml.pending, (state) => {
            state.startProcess1033RenameUmlStatus = 'pending'
            state.startProcess1033RenameUmlError = undefined
        })
        builder.addCase(startProcess1033RenameUml.fulfilled, (state, action) => {
            state.startProcess1033RenameUmlStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1033RenameUml.rejected, (state, action) => {
            state.startProcess1033RenameUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1033RenameUmlError = action.error.message
            } else {
                state.startProcess1033RenameUmlError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1033RenameUml.pending, (state) => {
            state.loadUserParamsProcess1033RenameUmlStatus = 'pending'
            state.loadUserParamsProcess1033RenameUmlError = undefined
        })
        builder.addCase(loadUserParamsProcess1033RenameUml.fulfilled, (state, action) => {
            state.loadUserParamsProcess1033RenameUmlStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1033RenameUml.rejected, (state, action) => {
            state.loadUserParamsProcess1033RenameUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1033RenameUmlError = action.error.message
            } else {
                state.loadUserParamsProcess1033RenameUmlError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1033RenameUml,
    resetstartProcess1033RenameUmlError,
    resetloadUserParamsProcess1033RenameUml,
    resetloadUserParamsProcess1033RenameUmlError,
    removeFromProcess1033RenameUmlListById,
    removeFromProcess1033RenameUmlListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1033RenameUmlSlice.actions
export default Process1033RenameUmlSlice.reducer
